<template lang="pug">
	.app-core--switch.flex-row.align-center.space(@click="toggleState()")
		.clickable.hoverable {{text}}
		DxSwitch.no-pointer-events(ref="switch", :value="!!innerValue", :text="$tCaption('Published')")
</template>

<script>
import { DxSwitch } from 'devextreme-vue/switch';

export default {
	props: ['value', 'beforeChange', 'text'],
	components: { DxSwitch },
	data() {
		return {
			innerValue: this.value
		}
	},
	watch: {
		value(v) {
			if (this.innerValue !== v) {
				this.toggleState(v);
			}
		}
	},
	computed: {
		
	},
	methods: {
		async toggleState(forcedValue) {
			if (__DEBUG__)
				console.debug('Toggle', forcedValue);
			if (forcedValue === void 0) {
				forcedValue = !this.innerValue;
			}
			if (this.innerValue === forcedValue) return;
			let canSet = true;
			if (this.beforeChange) {
				const newVal = await this.beforeChange();
				if (newVal === false)
					canSet = false;
			}
			if (canSet === false) return;
			this.innerValue = forcedValue;
			this.$emit('update:value', this.innerValue);
			this.$emit('change', this.innerValue);
			this.$refs.switch.instance._animateValue(forcedValue);			
		},
	}
};
</script>
<style lang="scss">
	.app-core--switch {
		
	}
</style>
